import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import { analysisActions as actions, contractReviewerActions } from '../../actions';
import { analysisConstants } from '../../constants';
import { history } from '../../helpers';
import PortfolioAnalysisInsights from './PortfolioAnalysisInsights';
import PortfolioAnalysisDocuments from './PortfolioAnalysisDocuments';
import PortfolioAnalysisSettings from './PortfolioAnalysisSettings';
import Navbar from './Navbar';
import PortfolioAnalysisFilterControl from './PortfolioAnalysisFilterControl';
import FilterPanel from './FilterPanel/FilterPanel';
import { PrivateRoute } from '../../components/PrivateRoute';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';

class PortfolioAnalysisView extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            analysisId: "",
            name: "",
            description: "",
            filteredDocumentAnalyses: [],
            contractTypes: [],
            insights: {},
            filter: [],
            concepts: [],
            governingLaws: [],
            periods: {},
            documents: [],
            showFilterPanel: false
        };

        this.loadingListener = new LoadingListener(
            [analysisConstants.GET_PORTFOLIO_ANALYSIS_REQUEST,
            analysisConstants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST]);
    }

    componentDidMount() {
        let { reportId } = this.props.match.params;
        if (this.props.reportId)
            reportId = this.props.reportId;

        if (this.props.id !== reportId) {
            this.props.deselectDocument();
        }

        if (this.state.analysisId !== reportId) {
            this.setState({ analysisId: reportId });
        }
        if (!this.isEmpty(this.props.portfolioAnalyses) && this.state.analysisId !== "") {
            this.filterAnalyses(this.props.filter, this.props.portfolioAnalyses[this.state.analysisId]);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.analysisId !== prevState.analysisId) {
            this.props.requestPortfolioAnalysis(this.state.analysisId);
        }

        if (prevProps.portfolioAnalyses !== this.props.portfolioAnalyses) {
            const analysis = this.props.portfolioAnalyses[this.state.analysisId];
            this.setState({ name: analysis.name, description: analysis.description });
            this.updateContractTypes();
            this.updateConcepts();
            this.updateGoverningLaws();
            this.updatePeriods();
        }

        if (prevState.filteredDocumentAnalyses !== this.state.filteredDocumentAnalyses) {
            this.updateInsights();
            this.updateDocuments();
        }

        if (prevState.contractTypes !== this.state.contractTypes || prevState.concepts !== this.state.concepts) {
            this.initializeFilter();
        }

        if (prevProps.filter !== this.props.filter) {
            this.filterAnalyses(this.props.filter, this.props.portfolioAnalyses[this.state.analysisId]);
        }

        if (this.props.exceptions !== prevProps.exceptions && this.props.exceptions.length > 0) {
            throw this.props.exceptions[0];
        }
    }

    initializeFilter = () => {
        const filter = { ...this.props.filter };
        filter.contractTypes = [...this.state.contractTypes];
        filter.concepts = Object.fromEntries(this.state.concepts.map(x => [x.code, 0]));
        filter.governingLaws = [...this.state.governingLaws];
        filter.periods = {};
        this.setState({ filter });

        this.props.filterAnalysis(filter);
    }

    isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    }

    filterAnalyses = (filter, portfolioAnalysis) => {
        if (filter === null || filter === undefined || filter.length === 0 ||
            (filter.contractTypes.length === 0 && filter.conceptGroups.length === 0 && filter.concepts.length === 0)) {
            this.setState({ filteredDocumentAnalyses: portfolioAnalysis.documentAnalyses });
            return;
        }

        this.setState({ filter });

        let filtered = portfolioAnalysis.documentAnalyses;
        filtered = this.filterContractTypes(filtered, filter);
        filtered = this.filterPeriods(filtered, filter, this.state.periods);
        filtered = this.filterConcepts(filtered, filter);
        filtered = this.filterGoverningLaws(filtered, filter);

        //Remove all duplicates.
        filtered = filtered.filter((value, index, self) => self.indexOf(value) === index);

        this.setState({ filteredDocumentAnalyses: filtered });
    }

    filterPeriods = (documentAnalyses, filter, periods) => {
        let toRemove = [];
        let getPeriodInDays = (period, periodType) => {
            if (!period || period !== period)
                return period;

            switch (periodType) {
                case "day": return period;
                case "week": return period * 7;
                case "month": return period * 30;
                case "year": return period * 365;
                default: return period;
            }

            return period;
        }

        for (const [code, period] of Object.entries(filter.periods)) {
            for (const da of documentAnalyses) {
                let shouldAllowEverything = !period || period['min'] === 0 && period['max'] >= periods[code];
                let highlights = da.highlights.filter(x => code === x.categoryCode);
                let matchesFilter = false;
                for (const highlight of highlights) {

                    //If we should just allow because the filter is allowing max.
                    if (shouldAllowEverything) {
                        highlight.isFilteredOut = false;
                        matchesFilter = true;
                        continue;
                    }

                    let value = 0;
                    if (highlight && highlight.dataExtractions && Object.keys(highlight.dataExtractions).length > 0) {
                        let num = parseInt(highlight.dataExtractions['period_num']);
                        let type = highlight.dataExtractions['period_type'];
                        value = getPeriodInDays(num, type);
                    }

                    if (!isNaN(value) && value >= period['min'] && value <= period['max']) {
                        highlight.isFilteredOut = false;
                        matchesFilter = true;
                    }
                    else highlight.isFilteredOut = true;
                }

                if (!matchesFilter && !shouldAllowEverything)
                    toRemove.push(da.documentId);
            }
        }

        let result = documentAnalyses.filter(x => !toRemove.includes(x.documentId));
        return result;
    }

    filterConcepts = (documentAnalyses, filter) => {
        let toRemove = [];
        for (const da of documentAnalyses) {
            for (const [code, state] of Object.entries(filter.concepts)) {
                if (state === 0) continue;

                let hasConcept = da.highlights.filter(x => code === x.categoryCode).length > 0;
                if (state === 1 && !hasConcept) toRemove.push(da.documentId);
                else if (state === 2 && hasConcept) toRemove.push(da.documentId);
            }
        }

        let result = documentAnalyses.filter(x => !toRemove.includes(x.documentId));
        return result;
    }

    filterContractTypes = (documentAnalyses, filter) => {
        let filtered = documentAnalyses.filter(x => filter.contractTypes.includes(x.contractType));
        return filtered;
    }

    filterGoverningLaws = (documentAnalyses, filter) => {
        const hasGoverningLawHighlight = (documentAnalysis) => documentAnalysis.highlights.some(h => (h.categoryCode === "G1" || h.categoryCode === "G1_1") && h.dataExtractions['jurisdiction']);
        let filtered = documentAnalyses.filter(x => x.highlights.some(h => filter.governingLaws.includes(h.dataExtractions['jurisdiction'])) ||
            (filter.governingLaws.includes('Missing') && !hasGoverningLawHighlight(x)));

        return filtered;
    }

    updateInsights = () => {
        const portfolioAnalysis = this.props.portfolioAnalyses[this.state.analysisId];
        const insights = {};

        for (const insight of portfolioAnalysis.insights) {
            insight.categoryCode = this.getCategoryCodeForInsightItem(insight.type);
            insight.values = [];

            switch (insight.type) {
                case "GoverningLaw": insight.filter = this.state.governingLaws;
            }

            for (const docAnalysis of this.state.filteredDocumentAnalyses) {

                let highlightIndexes = insight.data[docAnalysis.documentId];

                //If this document has no data, mark as missing.
                if (!highlightIndexes) {
                    let label = this.getLabelForInsightItems(insight.type, false, null, null);
                    let data = { wasFound: false, label, values: null, documentId: docAnalysis.documentId, code: null };
                    insight.values.push(data);
                    continue;
                }

                for (const hIndex of highlightIndexes) {
                    let wasFound = hIndex !== undefined && hIndex !== null && hIndex >= 0;
                    let label = this.getLabelForInsightItems(insight.type, wasFound, null, null);
                    let data = { wasFound, label, values: null, documentId: docAnalysis.documentId, code: null };

                    if (wasFound) {
                        //Find highlights with right index from doc.
                        let highlight = docAnalysis.highlights.find(h => h.indexInDocument === hIndex);

                        //If we can't find the highlight it's because it was filtered out.
                        if (!highlight || highlight.isFilteredOut)
                            continue;

                        //Get the values from the highlight.data_extractions dictionary/object.
                        let values = highlight.dataExtractions;
                        data.values = values;
                        data.label = this.getLabelForInsightItems(insight.type, wasFound, highlight.categoryCode, values);
                        data.code = highlight.categoryCode;
                    }

                    insight.values.push(data);
                }
            }

            insights[insight.type] = insight;
        }

        this.setState({ insights });
    }

    getLabelForInsightItems = (insightType, wasFound, categoryCode, values) => {
        switch (insightType) {
            case "PaymentTerm": {
                if (wasFound) return values && values['period_num'] ? this.addSToEnd(`${values['period_num']} ${values['period_type']}`) : 'Unknown';
                else return "Missing";
            }
            case "GoverningLaw": {
                if (wasFound) return values && values['jurisdiction'] ? values['jurisdiction'] : 'Unknown';
                else return "Missing";
            }
            case "AgreementTerm": {
                if (wasFound) return values && values['period_num'] ? this.addSToEnd(`${values['period_num']} ${values['period_type']}`) : 'Unknown';
                else return "Missing";
            }
            case "Confidentiality": return wasFound ? 'Yes' : 'No';
            case "NoticePeriod": {
                if (wasFound) return values && values['period_num'] ? this.addSToEnd(`${values['period_num']} ${values['period_type']}`) : 'Unknown';
                else return "Missing";
            }
            case "LimitationOfLiability": return wasFound ? 'Yes' : 'No';
            case "PriceAdjustment": return wasFound ? 'Yes' : 'No';
            case "ForceMajeure": return wasFound ? 'Yes' : 'No';
            case "Indemnities": return wasFound ? 'Yes' : 'No';
            case "ExclusionConsequentialDamages": return wasFound ? 'Yes' : 'No';
            case "Warranty": return wasFound ? 'Yes' : 'No';
            default: return "Unknown";
        }

        if (wasFound) return values && Object.values(values)[0] ? Object.values(values)[0] : 'Unknown';
        else return "Missing";
    }

    getCategoryCodeForInsightItem = (insightType) => {
        switch (insightType) {
            case "PaymentTerm": return "P1";
            case "GoverningLaw": return "G1";
            case "AgreementTerm": return "Agreement_term";
            case "Confidentiality": return "C1";
            case "NoticePeriod": return "notice_period_termination";
            case "LimitationOfLiability": return "L2";
            case "PriceAdjustment": return "price_adjustments";
            case "ForceMajeure": return "F1";
            case "Indemnities": return "I2";
            case "ExclusionConsequentialDamages": return "L1";
            case "Warranty": return "W1";
            default: return "";
        }
    }

    addSToEnd = (label) => {
        if (label.endsWith('day') || label.endsWith('month') || label.endsWith('year'))
            label += 's';

        return label;
    }

    updateDocuments = () => {
        let items = Object.values(this.state.filteredDocumentAnalyses);
        if (items === null || items.length === 0)
            this.setState({ documents: [] });

        const getHighlightIndexes = (highlights) => highlights.reduce((acc, { isFilteredOut, indexInDocument, categoryCode }) => {
            if (!isFilteredOut) {
                if (!acc[categoryCode] || indexInDocument < acc[categoryCode]) {
                    acc[categoryCode] = indexInDocument;
                }
            }
            return acc;
        }, {});

        let docs = items.map(x => ({
            id: x.documentId,
            filename: x.fileName,
            contractType: x.contractType,
            wasSaved: x.wasSaved,
            missingCount: x.missingHighlights.length,
            breachesCount: x.highlights.filter(h => h.breachData && h.breachData.isBreach).length,
            highlightIndexes: getHighlightIndexes(x.highlights)
        }));

        this.setState({ documents: docs });
    }

    updateConcepts = () => {
        let concepts = Object.values(this.getAllConcepts());
        this.setState({ concepts });
    }

    updateContractTypes = () => {
        if (!this.props.portfolioAnalyses || !this.props.portfolioAnalyses[this.state.analysisId])
            return [];

        let contractTypes = Object.values(this.props.portfolioAnalyses[this.state.analysisId].documentAnalyses.map(x => x.contractType));
        this.setState({ contractTypes });
    }

    updateGoverningLaws = () => {
        if (!this.props.portfolioAnalyses || !this.props.portfolioAnalyses[this.state.analysisId])
            return [];

        let insights = this.props.portfolioAnalyses[this.state.analysisId].insights;
        let govInsight = insights.filter(x => x.type === "GoverningLaw");
        let governingLaws = [];
        if (!govInsight || govInsight.length === 0) {
            governingLaws.push('Missing');
            this.setState({ governingLaws });
            return;
        }

        govInsight = govInsight[0];
        let docs = this.props.portfolioAnalyses[this.state.analysisId].documentAnalyses;
        for (const [docId, highlightIndexes] of Object.entries(govInsight.data)) {
            let doc = docs.filter(x => x.documentId === docId)[0];
            let highlight = doc.highlights.find(h => highlightIndexes.includes(h.indexInDocument));
            governingLaws.push(highlight.dataExtractions['jurisdiction']);
        }

        //Remove duplicates.
        governingLaws.push('Missing');
        governingLaws = governingLaws.filter((value, index, self) => self.indexOf(value) === index);
        this.setState({ governingLaws });
    }

    updatePeriods = () => {
        const analysis = this.props.portfolioAnalyses[this.state.analysisId];

        const getPeriodInDays = (period, periodType) => {
            if (!period || period !== period)
                return period;

            switch (periodType) {
                case "day": return period;
                case "week": return period * 7;
                case "month": return period * 30;
                case "year": return period * 365;
                default: return period;
            }

            return period;
        }

        const isNumeric = (string) => Number.isFinite(+string);

        const highestValues = {};
        for (const da of analysis.documentAnalyses) {
            const highlightsWithPeriods = da.highlights.filter(x => x.dataExtractions && x.dataExtractions['period_num']);
            highlightsWithPeriods.forEach(highlight => {
                const categoryCode = highlight.categoryCode;
                const periodNum = highlight.dataExtractions.period_num;
                const periodType = highlight.dataExtractions.period_type;

                // Save the period value if its higher than the ones seen so far.
                if (periodNum && isNumeric(periodNum) && periodType) {
                    let value = getPeriodInDays(parseInt(periodNum), periodType);
                    if (highestValues[categoryCode] === undefined || value > highestValues[categoryCode]) {
                        highestValues[categoryCode] = value;
                    }
                }
            });
        }

        this.setState({ periods: highestValues });
    }

    handleFilterChange = (filter) => {
        this.props.filterAnalysis(filter);
    }

    handleFilterReset = () => {
        this.initializeFilter();
    }

    toggleShowFilterPanel = () => {
        this.setState({ showFilterPanel: !this.state.showFilterPanel });
    }

    handleExportReport = (id) => {
        this.props.exportPortfolioAnalysis(id);
    }

    handleDeleteReport = (id) => {
        this.props.deletePortfolioAnalysis(id);
    }

    handleCreateNewReport = (name, desc, ids) => {
        this.props.requestNewPortfolioAnalysis(name, desc, ids);
    }

    handleUpdateReport = (id) => {
        this.props.updatePortfolioAnalysis(id);
    }

    getAllConcepts = () => {
        if (!this.props.portfolioAnalyses || !this.props.portfolioAnalyses[this.state.analysisId])
            return [];

        return this.props.portfolioAnalyses[this.state.analysisId].concepts;
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        const basePath = history.location.pathname && history.location.pathname.endsWith('/') ? history.location.pathname.slice(0, -1) : history.location.pathname;

        return (
            <div className="portfolio-analysis">
                {isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {!isLoading &&
                    <div>
                        {!this.props.hideNavbar &&
                            <Navbar match={this.props.match} />
                        }
                        <PortfolioAnalysisFilterControl
                            filter={this.props.filter}
                            onChange={this.handleFilterChange}
                            onTogglePanel={this.toggleShowFilterPanel}
                        />
                        <div className="flex-container">
                            <PrivateRoute path={`${this.props.match.path}`} exact component={(props) => (
                                <Redirect to={{ pathname: `${basePath}/insights`, state: { from: history.location } }} />
                            )}
                            />
                            <PrivateRoute path={`${this.props.match.path}/insights`} component={(props) => (
                                <PortfolioAnalysisInsights
                                    {...props}
                                    reportId={this.props.id}
                                    insights={this.state.insights}
                                    documents={this.state.documents}
                                    filter={this.state.filter}
                                    hideContractType={true}
                                />
                            )}
                            />
                            <PrivateRoute path={`${this.props.match.path}/settings`} component={(props) => (
                                <PortfolioAnalysisSettings
                                    id={this.props.id}
                                    name={this.state.name}
                                    description={this.state.description}
                                    documents={this.state.documents}
                                    onCreateNewReport={this.handleCreateNewReport}
                                    onUpdateReport={this.handleUpdateReport}
                                    onExportReport={this.handleExportReport}
                                    onDelete={this.handleDeleteReport}
                                />
                            )}
                            />
                            <PrivateRoute path={`${this.props.match.path}/documents`} component={(props) => (
                                <PortfolioAnalysisDocuments
                                    basePathForLinks={this.props.reportId ? '/workspace' : '/reports'}
                                    reportId={this.props.id}
                                    items={this.state.documents}
                                    hideContractType={true}
                                />
                            )}
                            />

                            {this.state.showFilterPanel &&
                                <FilterPanel
                                    filter={this.props.filter}
                                    contractTypes={this.state.contractTypes}
                                    concepts={this.state.concepts}
                                    insights={this.state.insights}
                                    governingLaws={this.state.governingLaws}
                                    periods={this.state.periods}
                                    onChange={this.handleFilterChange}
                                    onReset={this.handleFilterReset}
                                    hideContractType={true}
                                />
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect(
    state => state.analysis,
    dispatch => bindActionCreators({ ...actions, deselectDocument: contractReviewerActions.deselectDocument }, dispatch)
)(PortfolioAnalysisView);


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioAnalysisView.js